import React from 'react';
import dompurify from 'dompurify';

export const SurveyQuestion = ({ option }) => {
    return (
        <React.Fragment>
            <span className="block mb-2" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(option.surveyQuestion) }} />

            {option.ballotOptionDescription &&
                <span className="block mb-2" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(option.ballotOptionDescription) }} />
            }
        </React.Fragment>
    );
}